module.exports = __webpack_public_path__ + "img/IMG-20180803-WA0019.b6f6f2d6.jpg";